import hasPermissions from './hasPermissions';
export * from './hasPermissions';

export default hasPermissions;
